import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/stats/base/dists/t/cdf';
import __var_2__ from '@stdlib/stats/base/dists/t/ctor';
import __var_3__ from '@stdlib/stats/base/dists/t/entropy';
import __var_4__ from '@stdlib/stats/base/dists/t/kurtosis';
import __var_5__ from '@stdlib/stats/base/dists/t/logcdf';
import __var_6__ from '@stdlib/stats/base/dists/t/logpdf';
import __var_7__ from '@stdlib/stats/base/dists/t/mean';
import __var_8__ from '@stdlib/stats/base/dists/t/median';
import __var_9__ from '@stdlib/stats/base/dists/t/mode';
import __var_10__ from '@stdlib/stats/base/dists/t/pdf';
import __var_11__ from '@stdlib/stats/base/dists/t/quantile';
import __var_12__ from '@stdlib/stats/base/dists/t/skewness';
import __var_13__ from '@stdlib/stats/base/dists/t/stdev';
import __var_14__ from '@stdlib/stats/base/dists/t/variance';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace t
*/
var t = {};

/**
* @name cdf
* @memberof t
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/t/cdf}
*/
setReadOnly( t, 'cdf', __var_1__);

/**
* @name T
* @memberof t
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/t/ctor}
*/
setReadOnly( t, 'T', __var_2__);

/**
* @name entropy
* @memberof t
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/t/entropy}
*/
setReadOnly( t, 'entropy', __var_3__);

/**
* @name kurtosis
* @memberof t
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/t/kurtosis}
*/
setReadOnly( t, 'kurtosis', __var_4__);

/**
* @name logcdf
* @memberof t
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/t/logcdf}
*/
setReadOnly( t, 'logcdf', __var_5__);

/**
* @name logpdf
* @memberof t
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/t/logpdf}
*/
setReadOnly( t, 'logpdf', __var_6__);

/**
* @name mean
* @memberof t
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/t/mean}
*/
setReadOnly( t, 'mean', __var_7__);

/**
* @name median
* @memberof t
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/t/median}
*/
setReadOnly( t, 'median', __var_8__);

/**
* @name mode
* @memberof t
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/t/mode}
*/
setReadOnly( t, 'mode', __var_9__);

/**
* @name pdf
* @memberof t
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/t/pdf}
*/
setReadOnly( t, 'pdf', __var_10__);

/**
* @name quantile
* @memberof t
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/t/quantile}
*/
setReadOnly( t, 'quantile', __var_11__);

/**
* @name skewness
* @memberof t
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/t/skewness}
*/
setReadOnly( t, 'skewness', __var_12__);

/**
* @name stdev
* @memberof t
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/t/stdev}
*/
setReadOnly( t, 'stdev', __var_13__);

/**
* @name variance
* @memberof t
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/t/variance}
*/
setReadOnly( t, 'variance', __var_14__);


// EXPORTS //
export default t;

export { __var_1__ as cdf, __var_2__ as T, __var_3__ as entropy, __var_4__ as kurtosis, __var_5__ as logcdf, __var_6__ as logpdf, __var_7__ as mean, __var_8__ as median, __var_9__ as mode, __var_10__ as pdf, __var_11__ as quantile, __var_12__ as skewness, __var_13__ as stdev, __var_14__ as variance};